export const getHeaderIcon = (str: string) => {
  switch (str) {
    case 'question': {
      return 'pi pi-question';
    }
    case 'warning':
      return 'pi pi-exclamation-circle';
    default:
      return '';
  }
};
